var exports = {
  "zr": "x804f0401--782b40--root",
  "kL": "x804f0401--782b40--container",
  "Qs": "x804f0401--782b40--content",
  "pz": "x804f0401--782b40--sidebar",
};

module.exports = exports;
